import './Alert.scss';

import { Alert as AntdAlert } from 'antd';
import React from 'react';

interface AlertProps {
  type?: 'success' | 'info' | 'warning' | 'error';
  message?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
}

const Alert = ({ description, message, type, className, action }: AlertProps) => {
  return (
    <AntdAlert
      className={`Alert ${className}`}
      description={description}
      title={message}
      type={type}
      action={action}
    />
  );
};

export default Alert;
